// import React, { useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';

// export default function Navbar() {
//   const [open, setOpen] = useState(false);
//   const { isAuthenticated, logout } = useAuth();
//   const navigate = useNavigate();

//   const handleLogout = () => {
//     logout();
//     navigate('/');
//   };

//   return (
//     <header className="navbar">
//       <div className="navbar-inner">
//         <Link to="/" className="navbar-brand">
//           <span className="navbar-logo-badge">
//             <img src="/images/Logo.jpg" alt="Singumkhonto Wabasebenzi NPC logo" />
//           </span>
//           <span className="navbar-logo">
//             Singumkhonto <span>Wabasebenzi NPC</span>
//           </span>
//         </Link>

//         <nav className={`navbar-links ${open ? 'open' : ''}`}>
//           <Link to="/" onClick={() => setOpen(false)}>Home</Link>
//           <Link to="/about" onClick={() => setOpen(false)}>About Us</Link>
//           <Link to="/how-we-work" onClick={() => setOpen(false)}>How We Work</Link>
//           <Link to="/services" onClick={() => setOpen(false)}>Services</Link>
//           <Link to="/rights-library" onClick={() => setOpen(false)}>Rights Library</Link>
//           <Link to="/podcast" onClick={() => setOpen(false)}>Podcast</Link>
//           <Link to="/news" onClick={() => setOpen(false)}>News</Link>
//           <Link to="/contact" onClick={() => setOpen(false)}>Contact</Link>

//           {isAuthenticated ? (
//             <>
//               <Link to="/member/dashboard" className="btn btn-gold" style={{ padding: '8px 18px' }} onClick={() => setOpen(false)}>
//                 My Account
//               </Link>
//               <button className="btn btn-outline-dark" style={{ padding: '8px 18px' }} onClick={handleLogout}>
//                 Logout
//               </button>
//             </>
//           ) : (
//             <>
//               <Link to="/login" onClick={() => setOpen(false)}>Login</Link>
//               <Link to="/register" className="btn btn-gold" style={{ padding: '8px 18px' }} onClick={() => setOpen(false)}>
//                 Become a Member
//               </Link>
//             </>
//           )}
//         </nav>

//         <button className="navbar-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
//           {open ? '✕' : '☰'}
//         </button>
//       </div>
//     </header>
//   );
// }

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand">
          <span className="navbar-logo-badge">
            <img src="/images/Logo.jpg" alt="Singumkhonto Wabasebenzi NPC logo" />
          </span>
          <span className="navbar-logo">
            Singumkhonto <span>Wabasebenzi NPC</span>
          </span>
        </Link>

        <div className={`navbar-links ${open ? 'open' : ''}`}>
          <nav className="navbar-menu">
            <Link to="/" onClick={() => setOpen(false)}>Home</Link>
            <Link to="/about" onClick={() => setOpen(false)}>About Us</Link>
            <Link to="/how-we-work" onClick={() => setOpen(false)}>How We Work</Link>
            <Link to="/services" onClick={() => setOpen(false)}>Services</Link>
            <Link to="/rights-library" onClick={() => setOpen(false)}>Rights Library</Link>
            <Link to="/podcast" onClick={() => setOpen(false)}>Podcast</Link>
            <Link to="/news" onClick={() => setOpen(false)}>News</Link>
            <Link to="/contact" onClick={() => setOpen(false)}>Contact</Link>
          </nav>

          <div className="navbar-actions">
            {isAuthenticated ? (
              <>
                <Link to="/member/dashboard" className="btn btn-gold" style={{ padding: '8px 18px' }} onClick={() => setOpen(false)}>
                  My Account
                </Link>
                <button className="btn btn-outline-dark" style={{ padding: '8px 18px' }} onClick={handleLogout}>
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)}>Login</Link>
                <Link to="/register" className="btn btn-gold" style={{ padding: '8px 18px' }} onClick={() => setOpen(false)}>
                  Become a Member
                </Link>
              </>
            )}
          </div>
        </div>

        <button className="navbar-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? '✕' : '☰'}
        </button>
      </div>
    </header>
  );
}
